import { ORDER_BY } from 'constants/paginationOrder';
import { MOBILE_PAGE, MOBILE_SIZE } from 'constants/values/params';
import {
  FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS,
  FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS,
  FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED,
  CHANGE_PRODUCTS_PAGE,
  FETCH_SHOPPING_CART,
  FETCH_SHOPPING_CART_SUCCESS,
  FETCH_SHOPPING_CART_FAILED,
  UPDATE_SHOPPING_CART,
  UPDATE_SHOPPING_CART_SUCCESS,
  UPDATE_SHOPPING_CART_FAILED,
  SET_SHOPPING_CART_PRICES,
  ADD_SHOPPING_CART_PRODUCT,
  REMOVE_SHOPPING_CART_PRODUCT,
  CREATE_SHOPPING_CART,
  CREATE_SHOPPING_CART_SUCCESS,
  CREATE_SHOPPING_CART_FAILED,
  SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER,
  SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT,
  FETCH_GIFT_TABLE_INFO,
  FETCH_GIFT_TABLE_INFO_SUCCESS,
  FETCH_GIFT_TABLE_INFO_FAILED,
  SET_HAVE_A_SHOPPING_CART,
  SET_SHOPPING_CART_INFO,
  RESET_EXTERNAL_GIFT_TABLE,
  UPDATE_CART_INFO,
  UPDATE_CART_INFO_SUCCESS,
  UPDATE_CART_INFO_FAILED,
} from 'store/actions/externalGiftTable/types';

export const initialState = {
  externalGiftTableProducts: {
    params: {
      page: 1,
      size: 12,
      mobilePage: MOBILE_PAGE,
      mobileSize: MOBILE_SIZE,
      orderBy: ORDER_BY.ASC,
    },
    totalPages: 1,
    totalMobilePages: 1,
    totalElements: 10,
    results: {
      list: [],
      mobileList: [],
      allElements: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
  shoppingCart: {
    params: {
      page: 1,
      size: 12,
      mobilePage: 1,
      mobileSize: 12,
    },
    totalPages: 1,
    totalElements: 1,
    results: {
      list: [],
      mobileList: [],
      allElements: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
  updateShoppingCart: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  shoppingCartProducts: {
    data: [],
  },
  shoppingCartPrices: {
    total: 0,
    subtotal: 0,
    quantity: 0,
    discount: 0,
  },
  createShoppingCart: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  temporalProductOfNotLoggedUser: null,
  isLoggedAfterAddingTemporaryProduct: false,
  giftTableInfo: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  haveAShoppingCart: null,
  shoppingCartInfo: {
    data: {},
  },
  updateShoppingCartInfo: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {},
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS:
      return {
        ...state,
        externalGiftTableProducts: {
          ...state.externalGiftTableProducts,
          results: {
            ...state.externalGiftTableProducts.results,
            list: [],
            mobileList: [],
            allElements: [],
            loading: true,
            success: false,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_SUCCESS:
    case CHANGE_PRODUCTS_PAGE:
      return {
        ...state,
        externalGiftTableProducts: {
          ...state.externalGiftTableProducts,
          params: {
            ...state.externalGiftTableProducts.params,
            ...action.payload.params,
          },
          totalPages:
            action.payload.totalPages ||
            state.externalGiftTableProducts.totalPages,
          totalMobilePages:
            action.payload.totalMobilePages ||
            state.externalGiftTableProducts.totalPages,
          totalElements:
            action.payload.totalElements ||
            state.externalGiftTableProducts.totalPages,
          results: {
            ...state.externalGiftTableProducts.results,
            list: action.payload.list,
            mobileList: action.payload.mobileList,
            allElements: action.payload.allElements,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_EXTERNAL_GIFT_TABLE_PRODUCTS_FAILED:
      return {
        ...state,
        externalGiftTableProducts: {
          ...state.externalGiftTableProducts,
          results: {
            ...state.externalGiftTableProducts.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };
    case FETCH_SHOPPING_CART:
      return {
        ...state,
        shoppingCart: {
          ...state.shoppingCart,
          results: {
            ...state.shoppingCart.results,
            list: [],
            loading: false,
            success: false,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_SHOPPING_CART_SUCCESS:
      return {
        ...state,
        shoppingCart: {
          ...state.shoppingCart,
          params: {
            ...state.shoppingCart.params,
            ...action.payload.params,
          },
          totalPages: action.payload.totalPages,
          totalElements: action.payload.totalElements,
          results: {
            ...state.shoppingCart.results,
            list: action.payload.list,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_SHOPPING_CART_FAILED:
      return {
        ...state,
        shoppingCart: {
          ...state.shoppingCart,
          results: {
            ...state.shoppingCart.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };
    case UPDATE_SHOPPING_CART:
      return {
        ...state,
        updateShoppingCart: {
          ...initialState.updateShoppingCart,
          loading: true,
        },
      };
    case UPDATE_SHOPPING_CART_SUCCESS:
      return {
        ...state,
        updateShoppingCart: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case UPDATE_SHOPPING_CART_FAILED:
      return {
        ...state,
        updateShoppingCart: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.updateShoppingCart.data,
        },
      };
    case SET_SHOPPING_CART_PRICES:
      return {
        ...state,
        shoppingCartPrices: {
          ...state.shoppingCartPrices,
          ...action.payload,
        },
      };
    case ADD_SHOPPING_CART_PRODUCT:
    case REMOVE_SHOPPING_CART_PRODUCT:
      return {
        ...state,
        shoppingCartProducts: {
          ...state.shoppingCartProducts,
          data: action.payload,
        },
      };
    case CREATE_SHOPPING_CART:
      return {
        ...state,
        createShoppingCart: {
          ...initialState.createShoppingCart,
          loading: true,
        },
      };
    case CREATE_SHOPPING_CART_SUCCESS:
      return {
        ...state,
        createShoppingCart: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
        temporalProductOfNotLoggedUser: null,
        isLoggedAfterAddingTemporaryProduct: false,
      };
    case CREATE_SHOPPING_CART_FAILED:
      return {
        ...state,
        createShoppingCart: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.createShoppingCart.data,
        },
      };
    case SET_TEMPORAL_PRODUCT_OF_NOT_LOGGED_USER:
      return {
        ...state,
        temporalProductOfNotLoggedUser: action.payload,
      };
    case SET_LOGGED_AFTER_ADDING_TEMPORARY_PRODUCT:
      return {
        ...state,
        isLoggedAfterAddingTemporaryProduct: action.payload,
      };
    case FETCH_GIFT_TABLE_INFO:
      return {
        ...state,
        giftTableInfo: {
          ...initialState.giftTableInfo,
          loading: true,
        },
      };
    case FETCH_GIFT_TABLE_INFO_SUCCESS:
      return {
        ...state,
        giftTableInfo: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case FETCH_GIFT_TABLE_INFO_FAILED:
      return {
        ...state,
        giftTableInfo: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.giftTableInfo.data,
        },
      };
    case SET_HAVE_A_SHOPPING_CART:
      return {
        ...state,
        haveAShoppingCart: action.payload,
      };
    case SET_SHOPPING_CART_INFO:
      return {
        ...state,
        shoppingCartInfo: {
          data: action.payload,
        },
      };
    case UPDATE_CART_INFO:
      return {
        ...state,
        updateShoppingCartInfo: {
          ...initialState.updateShoppingCartInfo,
          loading: true,
        },
      };
    case UPDATE_CART_INFO_SUCCESS:
      return {
        ...state,
        updateShoppingCartInfo: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case UPDATE_CART_INFO_FAILED:
      return {
        ...state,
        updateShoppingCartInfo: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.updateShoppingCartInfo.data,
        },
      };
    case RESET_EXTERNAL_GIFT_TABLE:
      return initialState;
    default:
      return state;
  }
};
